import { render, staticRenderFns } from "./sushiNav.vue?vue&type=template&id=2e4758d6&scoped=true"
import script from "./sushiNav.vue?vue&type=script&lang=js"
export * from "./sushiNav.vue?vue&type=script&lang=js"
import style0 from "./sushiNav.vue?vue&type=style&index=0&id=2e4758d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4758d6",
  null
  
)

export default component.exports